import * as React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

export default function StickyFooter() {
  return (
    <Grid container justifyContent="center" sx={{ py: 2 }}>
      <Typography
        component="div" // avoid <p><div> nesting warning
        align="center"
        sx={{ color: "white" }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Link
            component={RouterLink}
            to="/terms"
            underline="none"
            sx={{ color: "white", fontWeight: 500 }}
          >
            Terms
          </Link>
          <Box component="span">|</Box>
          <Link
            component={RouterLink}
            to="/privacy"
            underline="none"
            sx={{ color: "white", fontWeight: 500 }}
          >
            Privacy
          </Link>
          <Box component="span">|</Box>
          <Typography
            component="a"
            href="tel:(480)-400-7890"
            sx={{
              color: "white",
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            (480)-400-7890
          </Typography>
        </Box>
      </Typography>
    </Grid>
  );
}
